import { Box, Button, Tab } from "@mui/material";
import Modal from "@mui/material/Modal";
import Grid from "@mui/material/Unstable_Grid2";
import { useEffect, useState } from "react";
import "../../../Common/CommonScss/ModalPopup.scss";
import CustomButton from "../../CustomButton/CustomButton";
import RKTextField from "../../FieldTypes/RKTextField/RKTextField";
// import '../../../Pages/Desktop/CMSPages/CMSPages.scss';
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { countryCodeOption } from "../../../Service/Type/ContactForm";
import {
  internationalMobileNumber,
  isEmpty,
  validateEmail
} from "../../../SupportingFiles/HelpingFunctions";
import Calendly from "../../FieldTypes/Calendly/Calendly";
import SearchDropdown from "../../FieldTypes/SearchDropdown/SearchDropdown";
import Loader from "../Loader/Loader";

type formTypes = {
  name: { value: string; warning: boolean };
  subject: { value: string; warning: boolean };
  mobile: { value: string; warning: boolean };
  email: { value: string; warning: boolean };
  message: { value: string; warning: boolean };
  company: { value: string; warning: boolean };
  country: { value: string; warning: boolean };
}

const GetInTouchModal = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: Function;
}) => {
  const [tabsVal, setTabsVal] = useState<"inquire" | "meeting">("inquire");
  const [loading, setLoading] = useState<boolean>(false);
  const [formFields, setFormFields] = useState<formTypes>({
    name: { value: "", warning: false },
    subject: { value: "", warning: false },
    mobile: { value: "", warning: false },
    email: { value: "", warning: false },
    message: { value: "", warning: false },
    company: { value: "", warning: false },
    country: { value: "", warning: false },
  });

  const fieldsUpdateState = (attrName: any, value: string) => {
    setFormFields({
      ...formFields, [attrName[0]]: {
        value: value, warning: isEmpty(value)
      }
    })
  };

  const validateForm = () => {
    let data = { ...formFields };
    data = {
      ...data,
      name: { ...data.name, warning: isEmpty(data.name.value) },
      subject: { ...data.subject, warning: isEmpty(data.subject.value) },
      mobile: { ...data.mobile, warning: !internationalMobileNumber(data.mobile.value, data.country.value) },
      email: { ...data.email, warning: !validateEmail(data.email.value) },
      message: { ...data.message, warning: isEmpty(data.message.value) },
      company: { ...data.company, warning: isEmpty(data.company.value) },
      country: { ...data.country, warning: isEmpty(data.country.value) },
    };
    setFormFields({ ...data });

    let hasError = false;
    Object.values(data)?.map((item) => {
      if (item.warning) hasError = true;
    });

    if (!hasError) {
      formSubmit();
    }
  };

  const formSubmit=()=>{
    setFormFields({
      name: { value: "", warning: false },
      subject: { value: "", warning: false },
      mobile: { value: "", warning: false },
      email: { value: "", warning: false },
      message: { value: "", warning: false },
      company: { value: "", warning: false },
      country: { value: "", warning: false },
    });
  }

  const closeModal = () => {
    setOpen(false);
    setTabsVal('inquire');
    setFormFields({
      name: { value: "", warning: false },
      subject: { value: "", warning: false },
      mobile: { value: "", warning: false },
      email: { value: "", warning: false },
      message: { value: "", warning: false },
      company: { value: "", warning: false },
      country: { value: "", warning: false },
    });
  }

  useEffect(() => {
    if (tabsVal === "meeting") {
      setTimeout(() => {
        setLoading(false)
      }, 3000);
    }
  }, [tabsVal])

  return (
    <Modal open={open}>
      <Box className="modalWrapper">
        {
          loading ? <Loader /> : null
        }
        <Box className="modalContent">
          <Grid container>
            <Button className="closePopup" onClick={closeModal} />
            <Grid xs={12}>
              <TabContext value={tabsVal}>
                <Box className="tabBox">
                  <TabList
                    className=""
                    onChange={(e, a: "inquire" | "meeting") => {
                      setTabsVal(a);
                      if (a === "meeting") {
                        setLoading(true)
                      }
                    }}
                  >
                    <Tab
                      className={tabsVal === "inquire" ? "active" : ""}
                      label="Inquire"
                      value="inquire"
                    />
                    <Tab
                      className={tabsVal === "meeting" ? "active" : ""}
                      label="Schedule a meeting"
                      value="meeting"
                    />
                  </TabList>
                </Box>
                {/* INQUIRE TAB  */}
                <TabPanel className="tabPanel" value="inquire" >
                  <Grid container>
                    <Grid xs={12} sm={8}>
                      <h3 className="heading">
                        <span>Contact</span> US
                      </h3>
                      <p className="para mb-4">
                        "Step into the future of policy management - lets make
                        insurance exciting together!"
                      </p>
                      <Box className="form_section">
                        <Grid container spacing={3}>
                          <Grid xs={6}>
                            <RKTextField
                              class_name="inputField"
                              title={"Name"}
                              value={formFields.name.value}
                              attrName={["name"]}
                              value_update={fieldsUpdateState}
                              warn_status={formFields.name.warning}
                              error_messg="Please enter name"
                            />
                          </Grid>
                          <Grid xs={6}>
                            <RKTextField
                              class_name="inputField"
                              title={"Subject"}
                              value={formFields.subject.value}
                              attrName={["subject"]}
                              value_update={fieldsUpdateState}
                              warn_status={formFields.subject.warning}
                              error_messg="Please enter subject"
                            />
                          </Grid>
                          <Grid xs={6}>
                            <SearchDropdown
                              class_name="inputField"
                              title={"Country"}
                              value={formFields.country.value}
                              attrName={["country"]}
                              value_update={fieldsUpdateState}
                              warn_status={formFields.country.warning}
                              error_message="Please select country"
                              data={countryCodeOption}
                            />
                          </Grid>
                          <Grid xs={6}>
                            <RKTextField
                              class_name="inputField"
                              title={"Phone Number"}
                              value={formFields.mobile.value}
                              attrName={["mobile"]}
                              value_update={fieldsUpdateState}
                              warn_status={formFields.mobile.warning}
                              error_messg={formFields.mobile.value ? "Please enter valid mobile" : "Please enter mobile"}
                              maxLength={15}
                              validation_type="NUMBER"
                            />
                          </Grid>
                          <Grid xs={6}>
                            <RKTextField
                              class_name="inputField"
                              title={"Email"}
                              value={formFields.email.value}
                              attrName={["email"]}
                              value_update={fieldsUpdateState}
                              warn_status={formFields.email.warning}
                              error_messg="Please enter email"
                            />
                          </Grid>
                          <Grid xs={6}>
                            <RKTextField
                              class_name="inputField "
                              title={"Company"}
                              value={formFields.company.value}
                              attrName={["company"]}
                              value_update={fieldsUpdateState}
                              warn_status={formFields.company.warning}
                              error_messg="Please enter company"
                            />
                          </Grid>
                          <Grid xs={12}>
                            <RKTextField
                              class_name="inputField "
                              title={"Message"}
                              value={formFields.message.value}
                              attrName={["message"]}
                              value_update={fieldsUpdateState}
                              warn_status={formFields.message.warning}
                              error_messg="Please enter message"
                            />
                          </Grid>
                          <Grid xs={12} textAlign="center" className="ctaBtn">
                            <CustomButton
                              class_name="blueXlBtn"
                              text_name="Submit Details"
                              onClickFunction={validateForm}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                    <Grid
                      xs={12}
                      sm={4}
                      display={"flex"}
                      alignItems={"end"}
                      className="img-section"
                    >
                      <img src="./images/contactus_img.svg" alt="contact" />
                    </Grid>
                  </Grid>
                </TabPanel>
                {/* MEETING TAB  */}
                <TabPanel className="tabPanel" value="meeting">
                  <Grid container>
                    <Grid xs={12} sm={8}>
                      <h3 className="heading">
                        <span>Schedule </span> a Meeting
                      </h3>
                      <p className="para mb-4">
                        "Step into the future of policy management - lets make
                        insurance exciting together!"
                      </p>
                      <Box className="form_section">
                        <Grid container spacing={3}>
                          <Grid xs={12}>
                            <Calendly />
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>

                    <Grid
                      xs={12}
                      sm={4}
                      display={"flex"}
                      alignItems={"end"}
                      className="img-section"
                    >
                      <img src="./images/contactus_img.svg" alt="contact" />
                    </Grid>
                  </Grid>
                </TabPanel>
              </TabContext>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};

export default GetInTouchModal;
